import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';

export function authenticationInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  if (localStorage.getItem('token')) {
    const reqWithHeaders = req.clone({
      headers: req.headers.set(
        'Authorization',
        `Token ${localStorage.getItem('token')}`
      ),
    });
    return next(reqWithHeaders);
  }
  return next(req);
}
